import React from 'react';
import "./index.css";

export class SectionSimpleText extends React.Component {


    render(){
        const {title, text, className} = this.props;
        return (
            <div className={`section-simple-text ${className || ''}`}>
                <h2>{title}</h2>
                <p>{text}</p>
            </div>
        )
    }
}